import { render, staticRenderFns } from "./Metodo_pagos.vue?vue&type=template&id=4f429ab8"
import script from "./Metodo_pagos.vue?vue&type=script&lang=js"
export * from "./Metodo_pagos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports